import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { login, getSession } from "../utils/auth";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const result = await login(username.trim(), password.trim());
    if (result.ok) {
      const session = getSession();
      if (session?.mustChangePassword) {
        navigate("/change-password", { replace: true });
      } else {
        const redirectTo = location.state?.from || "/dashboard";
        navigate(redirectTo, { replace: true });
      }
    } else {
      setError(result.message || "Login failed.");
      setLoading(false);
    }
  };

  return (
    <div className="page-login">
      <div className="login-left">
        <div className="login-left-content">
          <img src="/assets/img/logo/continentallogo.jpg" alt="CH BioBank" className="login-brand-logo" />
          <h1 className="login-brand-title">CH BioBank</h1>
          <p className="login-brand-desc">Securely manage biobank consent submissions, track participants, and access analytics — all in one dashboard.</p>
          <div className="login-features">
            <div className="login-feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg><span>Secure & Encrypted</span></div>
            <div className="login-feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg><span>Real-time Analytics</span></div>
            <div className="login-feature"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg><span>Participant Tracking</span></div>
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <h2 className="login-title">Welcome back</h2>
          <p className="login-subtitle">Sign in to access the dashboard</p>
          <form onSubmit={handleSubmit} autoComplete="off" noValidate>
            <div className="form-group">
              <label>Username</label>
              <input value={username} onChange={(e) => setUsername(e.target.value)} className="input-lg" required placeholder="Enter username" />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="input-lg" required placeholder="Enter password" />
            </div>
            <div className="login-actions">
              <button className="btn-primary-action login-btn" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <svg className="login-spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" strokeOpacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/></svg>
                    Signing in…
                  </>
                ) : "Sign In"}
              </button>
            </div>
            <div className="login-alt-actions">
              <button className="btn-outline-action" type="button" onClick={() => navigate("/")}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                Back to Home
              </button>
            </div>
            {error && <div className="form-alert alert-error">{error}</div>}
          </form>
          <p className="login-hint" style={{ display: "none" }}>Demo: <strong>admin / Password123!</strong></p>
        </div>
      </div>
    </div>
  );
}
